export * from './shape-text';
export * from './event';

export const MIN_FONT_SIZE = 6;

export const DEFAULT_LINE_HEIGHT_FACTOR = 1.4;
export const DEFAULT_FONT_COLOR = '#000000ff';
export const DEFAULT_TEXT_ZH = '双击编辑文字';
export const DEFAULT_TEXT_EN = 'New Text';
export const DEFAULT_TEXT_GRADIENT = { colors: [], angle: 0 };
